module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-image-28b035bdb3da82b88a1a023f0437553e.jpg";